import { ExternalLink } from 'lucide-react'

const POWERBI_URL =
  'https://app.powerbi.com/view?r=eyJrIjoiYjE2N2NjNzgtNWVkMy00ZjgzLThkM2EtNDlmNWZlYjJlZmU5IiwidCI6ImQyOTEyNDUyLTBhNTctNDhmNy05MDdkLTg2MzdkYjIwZTYwMyJ9'

export default function BiProjetos() {
  return (
    <div className="relative -m-4 md:-m-6 2xl:-m-10">
      <a
        href={POWERBI_URL}
        target="_blank"
        rel="noopener noreferrer"
        title="Abrir em nova aba"
        className="absolute right-4 top-4 z-10 inline-flex items-center justify-center rounded-lg bg-brand-500 p-2 text-white shadow-theme-sm transition-all duration-300 hover:bg-brand-600"
      >
        <ExternalLink className="h-4 w-4" />
      </a>
      <iframe
        title="Projetos"
        src={POWERBI_URL}
        className="block w-full"
        style={{ height: 'calc(100dvh - 81px)', border: 0 }}
        allowFullScreen
      />
    </div>
  )
}
